var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestWaitingForKeys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.93,
    y: 7.5,
    width: 16.15,
    height: 17,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_waiting-for-keys") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.23,14.82a4.61,4.61,0,0,0-.67-5.6,5.07,5.07,0,1,0-7.14,7.18,4.89,4.89,0,0,0,5.13,1.1l0.9,0.91H17v1.27H18.3V21h1.58v1.58h0.95v0.88a0.53,0.53,0,0,0,.17.49,0.73,0.73,0,0,0,.46.21H24V21.27Zm-4.48-2.24a1.58,1.58,0,1,1,0-2.24,1.58,1.58,0,0,1,0,2.24h0Zm0,0",
    fill: "#e4c05c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,16.21l-1.78,1.38,0.82,0.83H17v1.27H18.3V21h1.58v1.58h1v0.88a0.53,0.53,0,0,0,.17.49,0.73,0.73,0,0,0,.46.21H24V23.8Zm0,0",
    fill: "#dda86f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.65,9.24a2.22,2.22,0,1,0,2.22,2.21,2.21,2.21,0,0,0-2.22-2.21h0Zm0,3.8a1.58,1.58,0,1,1,1.58-1.58A1.58,1.58,0,0,1,11.65,13h0Zm0,0",
    fill: "#bc9c4d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.27,27.92l-0.69.36-0.11.06-0.11,0a12.57,12.57,0,0,1-3.12,1h0l-0.77.11h0a13,13,0,0,1-1.42.08A12.73,12.73,0,0,1,4,21.08l-0.08-.23a12.72,12.72,0,0,1,0-8l0-.08L4,12.54l0-.1A12.76,12.76,0,0,1,13,4.52h0l0.18,0h0a12.71,12.71,0,0,1,2.78-.32V5.45c0,0.41.26,0.52,0.57,0.26l2.76-2.34a0.59,0.59,0,0,0,0-.94l-2.8-2.29C16.16-.12,15.9,0,15.91.4v1.3A15,15,0,0,0,5.29,6.14Q4.87,6.56,4.49,7h0l0,0a15,15,0,0,0-3.6,9.36s0,0.05,0,.08,0,0.23,0,.35,0,0.38,0,.57c0,0,0,0,0,.07A15,15,0,0,0,4,26.11l0,0c0.19,0.24.39,0.48,0.59,0.71l0,0q0.31,0.35.64,0.68a15,15,0,0,0,8.15,4.22h0A15.31,15.31,0,0,0,16,32a15,15,0,0,0,6.39-1.41l0.12-.07,0.13-.06c0.28-.13.55-0.28,0.82-0.43a1.22,1.22,0,0,0-1.2-2.12h0Zm0,0",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.56,9.77a1.22,1.22,0,0,0,2-1.36C28.41,8.15,28.23,7.9,28,7.66a1.22,1.22,0,0,0-1.93,1.48c0.16,0.2.31,0.42,0.45,0.63h0Zm0,0",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1,13c0.08,0.24.15,0.5,0.21,0.75a1.22,1.22,0,1,0,2.36-.6c-0.08-.3-0.16-0.6-0.25-0.89A1.22,1.22,0,1,0,28.1,13h0Zm0,0",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.33,25.05a1.22,1.22,0,0,0-1.72.12c-0.17.19-.35,0.39-0.52,0.57a1.22,1.22,0,1,0,1.74,1.7c0.21-.22.42-0.45,0.62-0.68a1.22,1.22,0,0,0-.12-1.72h0Zm0,0",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,16.06a1.22,1.22,0,0,0-1.25,1.18c0,0.26,0,.52,0,0.77a1.22,1.22,0,0,0,1.1,1.32h0.11a1.22,1.22,0,0,0,1.21-1.11c0-.31,0-0.62.06-0.92A1.22,1.22,0,0,0,30,16.06h0Zm0,0",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.42,20.79a1.22,1.22,0,0,0-1.58.69c-0.09.24-.2,0.48-0.3,0.71a1.22,1.22,0,1,0,2.21,1c0.13-.28.25-0.56,0.36-0.85a1.22,1.22,0,0,0-.69-1.58h0Zm0,0",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.27,6.39A1.22,1.22,0,0,0,25,4.68c-0.25-.18-0.5-0.36-0.76-0.53a1.22,1.22,0,1,0-1.33,2l0.64,0.44a1.22,1.22,0,0,0,1.7-.25h0Zm0,0",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestWaitingForKeys);
export default __webpack_public_path__ + "static/media/request_waiting-for-keys.585f07bf15da838c1ecdb6cd73f0e0b7.svg";
export { ForwardRef as ReactComponent };